import { render } from "./AttrChart.vue?vue&type=template&id=2e5613e6"
import script from "./AttrChart.vue?vue&type=script&lang=js"
export * from "./AttrChart.vue?vue&type=script&lang=js"

import "./AttrChart.vue?vue&type=style&index=0&id=2e5613e6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e5613e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e5613e6', __exports__)) {
    api.reload('2e5613e6', __exports__)
  }
  
  module.hot.accept("./AttrChart.vue?vue&type=template&id=2e5613e6", () => {
    api.rerender('2e5613e6', render)
  })

}


export default __exports__